// eslint-disable-next-line import/prefer-default-export
import FinancialsModule from './index.vue';

const financialRoutes = [
  {
    path: '/financials',
    component: FinancialsModule,
    children: [
      {
        path: 'payByRequest/:requestId',
        name: 'PayByRequest',
        component: () => import(/* webpackChunkName: "sts-work-permits" */ './pages/pay-by-request.vue'),
        meta: {
          showForAllLoggedUsers: true,
          showForGuestUsers: true,
        },
      },
      {
        path: 'receipt/:id',
        name: 'Receipt',
        component: () => import(/* webpackChunkName: "sts-work-permits" */ './pages/receipt.vue'),
        meta: {
          showForAllLoggedUsers: true,
          showForGuestUsers: true,
        },
      },
      {
        path: 'checkout',
        name: 'Checkout',
        component: () => import(/* webpackChunkName: "sts-work-permits" */ './pages/checkout.vue'),
        meta: {
          showForAllLoggedUsers: true,
          showForGuestUsers: true,
        },
      },
      {
        path: 'shopping-cart',
        name: 'ShoppingCart',
        component: () => import(/* webpackChunkName: "sts-work-permits" */ './pages/shopping-cart.vue'),
        meta: {
          showForAllLoggedUsers: true,
          showForGuestUsers: true, // Todo: Shopping cart for guests? can guests make payments?
        },
      },
    ],
  },
];

export default financialRoutes;
